<div *ngIf="faqItems.length || fallbackContent" class="section-box">
  <h2 class="section-title" i18n="@@currencyDetail.faqs.title">FAQs</h2>
  <div *ngIf="faqItems.length" class="accordion">
    <div class="accordion-item" *ngFor="let item of faqItems" [class.open]="item.open">
      <h3 class="accordion-question-heading">
        <button class="accordion-header" (click)="toggle(item)">
          <span class="accordion-question">{{ item.question }}</span>
          <span class="accordion-icon"></span>
        </button>
      </h3>
      <div class="accordion-body" *ngIf="item.open">
        <div [innerHTML]="item.answer | safeHtml"></div>
      </div>
    </div>
  </div>
  <div *ngIf="fallbackContent" class="section-content" [innerHTML]="fallbackContent | safeHtml"></div>
</div>
